const useCustomOrgShowTime = (orgId: number) => ({ customShowTime: orgId !== 602 });

export default useCustomOrgShowTime;
